<template>
  <div class="container-fluid">
    <Loading v-if="this.isLoading()" />
    <AlertDialog v-if="this.isAlertDialog()" />
    <div class="row header bt-primary justify-content-between align-items-center">
      <div class="col-auto">
        <img
          class="titleimg"
          src="@/assets/acrypro/ambi_logo.png"
          width="100px"
          style="cursor: pointer"
          @click="backhome"
        />
      </div>
      <div class="col-auto">
        <a href="#" class="text-dark me-3" style="text-decoration: none">お問い合わせ</a>
      </div>
    </div>
    <div class="row" style="height: 70px"></div>
    <div class="row">
      <div class="col text-center">
        <p class="noto acry-foreground h2 fw-bold">メールアドレス入力</p>
      </div>
    </div>
    <template v-if="isEnd == false">
      <form>
        <div class="row mt-4 justify-content-center">
          <div class="col-auto text-start">
            <h4 class="textcolor text-start" style="font-size: 15px">メールアドレス</h4>
            <input
              type="email"
              class="input border border-1 border-gray rounded mt-1 acry-input"
              v-model="email"
              v-on:keydown.enter="this.resetPassword"
              placeholder="メールアドレス"
            />
            <p v-if="isMailError" class="mt-3 ms-2 text-danger">
              メールアドレスが正しくありません
            </p>
          </div>
          <div class="row justify-content-center mt-4">
            <div class="col-12 mt-2">
              <button
                type="button"
                class="registbtn acry-background"
                @click="this.resetPassword"
              >
                <h5 class="mt-2 fw-bold">送信</h5>
              </button>
            </div>
          </div>
        </div>
      </form>
    </template>
    <template v-if="isEnd">
      <div class="row ps-3">
        <p>メールアドレス確認用メールを送信しました。</p>
        <br />
        <p>メールをご確認いただき認証を完了お願いします。</p>
      </div>
    </template>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/database";
import "firebase/auth";
import "firebase/analytics";
import "firebase/functions";
import { Common } from "@/js/common.js";
import AlertDialog from "@/components/acyrpro/modal/dialog/AlertDialog_Ap.vue";
import Loading from "@/components/modal/dialog/Loading.vue";
import router from "../router";

export default {
  name: "AcryProForgotPassword",
  components: { AlertDialog, Loading },
  props: {},
  data() {
    return {
      email: "",
      isEnd: false,
      isMailError: false,
    };
  },
  watch: {
    email() {
      this.isMailError = false;
    },
  },
  created() {},
  methods: {
    resetPassword() {
      if (Common.isInValidEmail(this.email)) {
        console.log("エラfdklさjf");
        this.isMailError = true;
      }
      if (this.isMailError) {
        return;
      }
      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          firebase.auth().signOut();
          this.$store.commit("showMessage", "確認のメールを送信しました");
        })
        .catch((error) => {
          console.log(error.message);
        });
    },
    isAlertDialog() {
      return this.$store.state.isAlertDialog;
    },
    isLoading() {
      return this.$store.state.isLoading;
    },
    backhome() {
      router.push("/");
    },
  },
};
</script>

<style scoped>
.login {
  width: 500px;
  height: 300px;
}
.registbtn {
  color: white;
  width: 320px;
  height: 62px;
  vertical-align: middle;
  border-radius: 32px;
  border: none;
}
.registbtn :hover {
  color: white;
}
.acry-input {
  width: 320px;
  height: 48px;
  padding-left: 10px;
}
</style>
